import type { ButtonProps } from '@archipro-design/aria';

import { Link } from '@remix-run/react';
import { useWebsiteReferralTracking } from '~/modules/tracking/util/websiteTracking';
import { Button as RoccoButton } from '@archipro/rocco/components/button';

type CTAHeaderType = 'Product' | 'Article';
interface PageDetailHeaderCTAProps {
    pageType: CTAHeaderType;
    pageID: number;
    website?: string | null;
    primaryCTAButtonLabel?: string;
    primaryCTAButtonOnClick?: () => void;
    primaryCTAButtonLink?: string;
    //This is bad - will fix up with the rest of this later
    professionalID?: number;
    professionalTitle: string;
    // allow primaryCTAButton style override
    primaryCTAButtonProps?: Partial<ButtonProps>;
}

const PageDetailHeaderCTA = ({
    pageID,
    website,
    primaryCTAButtonLabel,
    primaryCTAButtonOnClick,
    primaryCTAButtonLink,
    professionalTitle,
}: PageDetailHeaderCTAProps) => {
    const {
        referralTrackingURL,
        referralTrackingClass,
        referralTrackingParams,
    } = useWebsiteReferralTracking(website ?? undefined, {
        libraryItemID: pageID,
        professionalTitle,
    });

    return (
        <div className="flex gap-4">
            {referralTrackingURL && (
                <RoccoButton
                    color="secondary"
                    weight="default"
                    size={'larger'}
                    asChild
                >
                    <a
                        href={referralTrackingURL}
                        target="_blank"
                        rel="noreferrer"
                        className={referralTrackingClass}
                        {...referralTrackingParams}
                    >
                        Visit Website
                    </a>
                </RoccoButton>
            )}
            {primaryCTAButtonLabel && (
                <>
                    {primaryCTAButtonLink ? (
                        <RoccoButton
                            color="primary"
                            weight="default"
                            size={'larger'}
                            asChild
                        >
                            <Link to={primaryCTAButtonLink}>
                                {primaryCTAButtonLabel}
                            </Link>
                        </RoccoButton>
                    ) : (
                        primaryCTAButtonOnClick && (
                            <RoccoButton
                                weight="default"
                                size={'larger'}
                                onClick={primaryCTAButtonOnClick}
                            >
                                {primaryCTAButtonLabel}
                            </RoccoButton>
                        )
                    )}
                </>
            )}
        </div>
    );
};

export default PageDetailHeaderCTA;
